module.exports = __webpack_public_path__ + "img/son.d4c21876.svg";